<template>
  <div class="container-md">
    <h1 class="page-header">Users</h1>

    <DbTableControl :buttons="buttons"></DbTableControl>

    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Username</th>
            <th>Name</th>
            <th>Role</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="i in items" :key="i.id">
            <td>
              <router-link class="d-block" :to="'/user/' + i.id" v-if="user.id===1 || user.id===i.id">{{ i.username }}</router-link>
              <span v-else>{{ i.username }}</span>
            </td>
            <td>
              {{ i.name }}
            </td>
            <td>
              {{ i.role }}
            </td>
            <td>
              <a class="d-block" :href="'mailto:' + i.email">{{ i.email }}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { createWhereTextSearch } from "../lib/sql.js";
import { authFetch, getUser } from "../lib/auth.js";
import dbTableMixin from "../lib/dbtable-mixin";
import DbTableControl from "../components/DbTableControl";

export default {
  mixins: [dbTableMixin],
  components: {
    DbTableControl,
  },
  data() {
    return {
      buttons: [
        {
          to: "/user",
          text: "Add user",
          accesskey: "a",
          fa: "plus",
        },
      ],
      items: [],
      user: null,
    };
  },
  methods: {
    load() {
      getUser().then(user => this.user = user)
      
      let uri = "/db/user?select=id,username,name,email,role&sort=username";
      if (this.searchtext) {
        uri +=
          "&where=" +
          encodeURIComponent(createWhereTextSearch(this.searchtext, ["username", "name", "email"]));
      }
      authFetch(uri)
        .then((resp) => resp.json())
        .then((data) => (this.items = data));
    },
  },
};
</script>